export const GET_CITY_API = 'GET_CITY_API'
